export default class Debugger {
  debugRoutes(fromState, fromParams, toState, toParams) {
    const routeDebug = {};

    routeDebug.from = {
      state: fromState.name,
      url: fromState.url,
      params: JSON.stringify(fromParams),
    };

    routeDebug.to = {
      state: toState.name,
      url: toState.url,
      params: JSON.stringify(toParams),
    };

    console.table(routeDebug);
  }
}
